export default __webpack_public_path__ + "static/media/pan-around.ac9363a4.svg";